import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=59d5abe7&scoped=true&"
import script from "./NotificationHistory.vue?vue&type=script&lang=js&"
export * from "./NotificationHistory.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHistory.vue?vue&type=style&index=0&id=59d5abe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5abe7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
